import { Box } from 'reflexbox';
import styled from 'styled-components';
import { healthLevelColor } from '~/components/HealthIcon';

import { colors } from '~/styles/colors';

export const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;

  background-color: ${`${colors.Grey030}99`};

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  width: 100%;
  height: 100%;
`;

export const ClearBtn = styled.span`
  color: ${colors.Blue300};
  font-size: 10px;
  text-decoration: underline;
`;

export const Container = styled.div``;

export const ContentDate = styled.div`
  position: relative;
  border: 1px solid ${colors.GreyLight};
  border-radius: 5px;
  min-height: 50px;
  .CalendarDay__selected_span {
    background: #D0D2F1;
    border: 1px double #F4EBEB;
    color: #000;
  }
  .react-datepicker__month-text--keyboard-selected {
    background-color: ${colors.BlueSecondary};
  }
  .react-datepicker__triangle {
    left: -130px !important;
  }
  .react-datepicker__header {
    background-color: white;
    border-bottom: none;
  }
  .react-datepicker-wrapper {
    display: block;
    .react-datepicker__input-container {
      input[type="text"] {
        border: none;
        font-size: 12px;
        outline: none;
        line-height: 19px;
        padding: 0px 40px 0px 14px;
        background: none;
        color: #464555;
      }
    }
  }
  .SingleDatePicker {
    display: block;
    position: initial;
  }
  .SingleDatePickerInput {
    display: block;
    position: relative;
    border: none;
    .DateInput {
      display: block;
      position: relative;
      width: 100%;
      .DateInput_input {
        outline: none;
        font-size: 12px;
        line-height: 19px;
        padding: 0px 40px 0px 14px;
        color: ${colors.Grey400};
        width: 100%;
      }
      .DateInput_input__focused {
        border: none;
      }
    }
  }
  .DateRangePickerInput {
    .DateRangePickerInput_arrow {
      width: 15px;
    }
    .DateInput {
      .DateInput_input {
        outline: none;
        font-size: 12px;
        line-height: 19px;
        padding: 0px 15px 0px 14px;
        color: ${colors.Grey400};
      }
      .DateInput_input__focused {
        border: none;
      }
    }
  }
  .DateInput_fang {
    z-index: 1;
  }
  .SingleDatePicker_picker {
    width: 100%;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active {
    background: ${colors.BlueSecondary};
    border: 1px double ${colors.BlueSecondary};
    color: ${colors.White};
    font-weight: bold;
  }
  .CalendarDay__selected:hover {
    background: ${colors.BlueSecondary};
    border: 1px double ${colors.BlueSecondary};
    color: ${colors.Black};
  }
  .DayPickerKeyboardShortcuts_show__bottomRight::before {
    border-right: 33px solid ${colors.BlueSecondary};
  }
  .DayPickerKeyboardShortcuts_show__bottomRight:hover::before {
    border-right: 33px solid ${colors.BlueSecondary};
  }

  .DayPickerKeyboardShortcuts_show__bottomRight::before {
    display: none;
  }

  .CalendarMonth_caption {
    color: #000;
    text-transform: capitalize;
  }

  .CalendarMonth_caption {
    color: #000;
    text-transform: capitalize;
  }
  .DayPickerKeyboardShortcuts_show__bottomRight::before {
    display: none;
  }
  .CalendarDay__hovered_span, .CalendarDay__hovered_span:hover {
    background: #E5E6F8;
    border: 1px double #F4EBEB;
    color: #000;
  }
  .CalendarDay__selected_span:hover {
    background: #B5B7DD;
    border: 1px double #B5B7DD;
    color: #fff;
  }
`;

export const ContainerArrowLeft = styled.div<{disabled: boolean }>(
  ({
    disabled,
  }) => `
  display: flex;
  width: 35px;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #EDEDED;
  cursor: pointer;
  pointer-events: ${disabled ? 'none' : 'all'}
`,
);
export const ContainerArrowRight = styled.div<{disabled: boolean }>(
  ({
    disabled,
  }) => `
  display: flex;
  width: 35px;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #EDEDED;
  cursor: pointer;
  pointer-events: ${disabled ? 'none' : 'all'}
`,
);

export const LabelData = styled.div`
  position: relative;
  top: 3px;
  margin-left: 13px;
  font-size: 11px;
  font-weight: 700;
  line-height: 15px;
`;

export const ButtonOptions = styled.div<{ disabled?: boolean }>(
  ({ disabled }) => `
  padding: 5px;
  display: flex;
  gap: 5px;
  min-width: 97px;
  flex-direction: row;
  height: max-content;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  border-radius: 11px;
  border: 1px solid;
  border-color: #e3e3e3;
  cursor: pointer;

    ${disabled && `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`,
);

export const StyledBox = styled(Box)(
  (props: { health }) => `
  display: flex;
  align-items: center;
  justify-content: flex-start;

  div {
    background-color: ${healthLevelColor(props.health)};
  }
`,
);

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px 0px 0px;
  border-radius: 8px;
  width: 25px;
  height: 25px;

  svg {
    width: 17px;
    height: 15px;
  }
`;

export const SelectedStatusText = styled.span<{ health }>(
  ({ health }) => `
  margin-top: 12px;
  position: absolute;
  font-weight: bold;
  color:  ${healthLevelColor(health)};
`,
);

export const ContainerButtonStatusOpen = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-items: center;
  z-index: 12;
  border: 0.8px solid #5050502B;
  border-radius: 4px;
  background: #FFFFFF;
  overflow-x: hidden;
  height: max-content;
  width: 110px;
  cursor: pointer;
  `;

export const OptionsButtonsStatus = styled.p<{ disabled?: boolean }>`
  padding: 5px;
  margin: 0;
  transition: filter 0.2s ease;
  cursor: pointer;
  font-size: 12px;
  width: 100%;
  display: flex;
  align-items: center;


  ${({ disabled }) => disabled && `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    &:hover {
      filter: none;
    }
  `}
`;

export const ContainerModal = styled.div`
  padding: 25px 80px 0px 80px
`;

export const ModalTitle = styled.p`
  font-size: 20px;
  font-weight: 600;
  margin: 0px;
`;

export const ModalSubTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #5D5D5D;
  margin: 0px;
`;

export const ModalTextTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  margin: 0px;
`;

export const ModalText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #5D5D5D;
  margin: 0px;
`;

export const ContainerModalInputs = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 200px;
  justify-content: 'center';
`;

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

export const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 100%;
  margin-top: 1px;
  margin-left: 16px;
  margin-right: 16px;
  color: #202370;
  font-size: 11px;
  font-weight: bold;
`;

export const TextLine = styled.div`
  display: flex;
  align-items: center;
  color: #5d5d5d;
`;

export const TableWrapper = styled.div`
  padding: 20px 29px 20px 21px;
`;

export const ModalCancel = styled.p`
  font-size: 11px;
  color: ${colors.Blue500};
  text-decoration: underline;
  width: 100%;
  text-align: initial;
  margin-top: 8px;
  &:hover {
    color: ${colors.Blue400};
  }
`;
